var base = require('settings/invoices');

Vue.component('spark-invoices', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/invoices.js